import React from 'react'

import { CommonLogoWithBack, CommonLogoWithBackProps } from '../CommonLogoWithBack'
import WixStudioLogo from '../icons/WixStudioLogo.svg'

type WixStudioLogoWithBackProps = Omit<CommonLogoWithBackProps, 'logo'> & { logoColor?: string }

export const WixStudioLogoWithBack = (props: WixStudioLogoWithBackProps) => {
  return <CommonLogoWithBack {...props} logo={<WixStudioLogo height={27} width={167} fill={props.logoColor} />} />
}
